import type { StripeStoreProduct } from '@inkitt/contracts-common';
import type Stripe from 'stripe';

export type BundleType = StripeStoreProduct;

export const partitionByInterval = (subscriptions: StripeStoreProduct[]) => {
  const monthly: StripeStoreProduct[] = [];
  const yearly: StripeStoreProduct[] = [];
  const lifetime: StripeStoreProduct[] = [];

  subscriptions.forEach((sub) => {
    const interval = sub.price.recurring?.interval;
    if (interval === 'month') {
      monthly.push(sub);
    } else if (interval === 'year') {
      yearly.push(sub);
    } else if (sub.product.metadata.type === 'lifetime') {
      lifetime.push(sub);
    }
  });

  return { monthly, yearly, lifetime };
};

export const getProductDisplayName = (product: Stripe.Product): string => {
  return product.name || product.metadata.displayName || 'Subscription';
};

export const getTrialDaysFromMetadata = (product: Stripe.Product): number | undefined => {
  const freeDays = product.metadata.freeDays || product.metadata.free_days;
  return freeDays ? parseInt(freeDays, 10) : undefined;
};

export const isYearlyBundle = (bundle: StripeStoreProduct): boolean => {
  return bundle.price.recurring?.interval === 'year';
};

export const isMostPopular = (bundle: StripeStoreProduct): boolean => {
  return bundle.product.metadata.mostPopular === 'true' || isYearlyBundle(bundle);
};
